import { render, staticRenderFns } from "./testRouter2.vue?vue&type=template&id=93a63ee8&scoped=true"
import script from "./testRouter2.vue?vue&type=script&lang=js"
export * from "./testRouter2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a63ee8",
  null
  
)

export default component.exports